module.exports = __webpack_public_path__ + "static/media/care-services.ca12b1bf.svg";